module.exports = __webpack_public_path__ + "static/media/day09.c4828da5.jpg";